import React from "react";
import GroupBookingMainPage from "./groups/GroupBookingMainPage";
import GroupMainPage from "./assign-group/GroupMainPage";
import ModelGroupMainPage from "./assign-model-group/ModelGroupMainPage";
import FilterManagement from "../filter-management/FilterManagement";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { OwcExpandable } from "@one/react";
import DATA_LABEL_TABLE from "../../../utils/constants/dataLabelTable";
import {
  BookingAccessControlProvider,
} from "./BookingAccessControlContext";
import styles from "./BookingAccessControl.module.scss";

const PANEL_KEYS = {
  create: "createGroupAccordion",
  assign: "assignGroupAccordion",
  assignModel: "assignModelGroupAccordion",
  filterManagement: "filterManagementAccordion",
};

const INITIAL_PANELS_STATE = {
  [PANEL_KEYS.create]: true,
  [PANEL_KEYS.assign]: false,
  [PANEL_KEYS.assignModel]: false,
  [PANEL_KEYS.filterManagement]: false,
};

const BookingAccessControl = ({ getBookingItems }) => {
  const [expandedPanels, setExpandedPanels] = React.useState(INITIAL_PANELS_STATE);
  const [groupSearchEvent, setGroupSearchEvent] = React.useState({
    query: "",
    version: 0,
  });

  const { trackPageView } = useMatomo();
  React.useEffect(() => {
    trackPageView({
      documentTitle: "Admin Panel/Booking access control",
      href: `${window.location?.origin}/AdminPanel/BookingAccessControl`,
    });
    // Removed getBookingItems() call - instruments are now loaded on-demand via Redux
    // eslint-disable-next-line
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpandedPanels((prev) => ({
      ...prev,
      [panel]: Boolean(isExpanded),
    }));
  };

  const openAllWithGroupSearch = React.useCallback((query = "") => {
    setExpandedPanels({
      [PANEL_KEYS.create]: false,
      [PANEL_KEYS.assign]: true,
      [PANEL_KEYS.assignModel]: true,
      [PANEL_KEYS.filterManagement]: true,
    });
    setGroupSearchEvent((prev) => ({
      query,
      version: prev.version + 1,
    }));
  }, []);

  return (
    <>
      <BookingAccessControlProvider
        value={{
          groupSearchEvent,
          openAllWithGroupSearch,
        }}
      >
        <div>
          <OwcExpandable
            variant="standard"
            round
            expanded={expandedPanels[PANEL_KEYS.create]}
            onChange={handleChange(PANEL_KEYS.create)}
            className={styles.OwcExpandable}
          >
            <span slot="title">Create or edit booking group</span>
            <span
              slot="content"
              style={{
                minHeight: "fit-content",
                overflowY: "scroll",
              }}
            >
              <GroupBookingMainPage />
            </span>
          </OwcExpandable>

          <OwcExpandable
            variant="standard"
            round
            expanded={expandedPanels[PANEL_KEYS.assign]}
            onChange={handleChange(PANEL_KEYS.assign)}
            className={styles.OwcExpandable}
          >
            <span slot="title">Assign group to equipment</span>

            <span
              slot="content"
              style={{
                minHeight: "fit-content",
                overflowY: "scroll",
              }}
            >
              <GroupMainPage />
            </span>
          </OwcExpandable>
          <OwcExpandable
            variant="standard"
            round
            expanded={expandedPanels[PANEL_KEYS.assignModel]}
            onChange={handleChange(PANEL_KEYS.assignModel)}
            className={styles.OwcExpandable}
          >
            <span slot="title">Assign group to equipment model and location</span>

            <span
              slot="content"
              style={{
                minHeight: "fit-content",
                overflowY: "scroll",
              }}
            >
              <ModelGroupMainPage />
            </span>
          </OwcExpandable>

          <OwcExpandable
            variant="standard"
            round
            expanded={expandedPanels[PANEL_KEYS.filterManagement]}
            onChange={handleChange(PANEL_KEYS.filterManagement)}
            className={styles.OwcExpandable}
          >
            <span slot="title">{DATA_LABEL_TABLE.ADMIN_TABS.filter_management}</span>

            <span
              slot="content"
              style={{
                minHeight: "fit-content",
                overflowY: "scroll",
              }}
            >
              <FilterManagement getBookingItems={getBookingItems} />
            </span>
          </OwcExpandable>
        </div>
      </BookingAccessControlProvider>
    </>
  );
};

export default BookingAccessControl;
